<template>
    <div  class="logo-con">
        <div class="b-m">{{title}}</div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    name:'logo',
    computed: {
        ...mapGetters('app/',['title']),
    },
}
</script>
